export default __webpack_public_path__ + "static/media/selfie.2a2c25bf.svg";